import { fromJS } from 'immutable';
import {
  VIEW_MODE,
  SORT_BY_TIME,
  USER_TYPE,
  USER_TABS,
} from 'constants/common';

import * as types from './constants';

const initState = fromJS({
  filters: {
    status: undefined,
    skip: 0,
    take: 10,
    terms: '',
    page: 1,
  },
});

export default (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.UPDATE_FILTERS: {
      return state.set('filters', fromJS(payload));
    }
    default:
      return state;
  }
};
